import { Connector } from "@web3-react/types";
import { getNetworkConnection, walletConnectConnection } from "../connectors";
import {
  ChainIdLegacy,
  SupportedChainValue,
  isSupportedChainId,
} from "@silo/types";
import { getServerRpcUrls } from "@silo/utils";

export const switchChain = async (
  connector: Connector,
  chainId: ChainIdLegacy
) => {
  const networkConnection = getNetworkConnection();
  if (!isSupportedChainId(chainId)) {
    throw new Error(
      `Chain ${chainId} not supported for connector (${typeof connector})`
    );
  } else if (
    connector === walletConnectConnection.connector ||
    connector === networkConnection.connector
  ) {
    await connector.activate(chainId);
  } else {
    const info = CHAIN_INFO[chainId];
    const addChainParameter = {
      chainId,
      chainName: info.label,
      rpcUrls: getServerRpcUrls(chainId),
      nativeCurrency: info.nativeCurrency,
      blockExplorerUrls: [info.explorer],
    };
    await connector.activate(addChainParameter);
  }
};

const CHAIN_INFO: SupportedChainValue<{
  explorer: string;
  label: string;
  nativeCurrency: any;
}> = {
  [ChainIdLegacy.MAINNET]: {
    explorer: "https://etherscan.io/",
    label: "Ethereum",
    nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  },
  [ChainIdLegacy.ARBITRUM]: {
    explorer: "https://arbiscan.io/",
    label: "Arbitrum",
    nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  },
  [ChainIdLegacy.OPTIMISM]: {
    explorer: "https://mainnet.optimism.io",
    label: "Optimism",
    nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  },
  [ChainIdLegacy.BASE]: {
    explorer: "https://basescan.org/",
    label: "Base",
    nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  },
  [ChainIdLegacy.LOCAL]: {
    explorer: "https://etherscan.io/",
    label: "Ethereum",
    nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  },
  [ChainIdLegacy.ANVIL]: {
    explorer: "https://etherscan.io/",
    label: "Ethereum",
    nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  },
};
